"use client";

import type { FC, HTMLAttributes } from "react";
import { mergeClasses } from "@huub-web/utils";

import { edgeStyle, edgeContentStyle, edgeLeadingStyle } from "./Edges.css";
import type { ClassNameProp, ChildrenProp, EdgesProps } from "../../props";

/**
 * Edges is a layout component that allows you to add content to the left and right edges of a container.
 */
export const Edges: FC<
  HTMLAttributes<HTMLDivElement> &
    EdgesProps &
    ChildrenProp &
    ClassNameProp & { hideOverflow?: boolean }
> = ({
  className,
  leading,
  leadingClassName,
  trailing,
  trailingClassName,
  hideOverflow = false,
  children,
  ...props
}) => (
  <>
    {leading && (
      <Edge className={mergeClasses(edgeLeadingStyle, leadingClassName)}>
        {leading}
      </Edge>
    )}
    <div
      className={mergeClasses(edgeContentStyle({ hideOverflow }), className)}
      {...props}
    >
      {children}
    </div>
    {trailing && <Edge className={trailingClassName}>{trailing}</Edge>}
  </>
);

export const Edge: FC<ChildrenProp & ClassNameProp> = ({
  children,
  className,
}) => <div className={mergeClasses(edgeStyle(), className)}>{children}</div>;
